import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { Button } from 'components/Button';

export const PopUpRedAlertContainer = styled.div<{ isMostRecent: boolean }>`
  border-radius: 2px;
  width: 800px;
  margin-bottom: 10px;
  opacity: ${(props) => (props.isMostRecent ? 1 : 0.4)};
  background-color: ${({ theme }) => theme.palette.common.white};
`;

const PopUpRedAlertText = styled.p`
  font-size: 1.8rem;
  line-height: 2.1rem;
  color: ${({ theme }) => theme.palette.common.white};
  flex-shrink: 0;
  margin: 0;
`;
export const PopUpRedAlertUserLink = styled(Link)`
  margin: 0 16px;
  flex-grow: 1;
  color: ${({ theme }) => theme.palette.common.white};
  text-decoration: none;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.15px;
`;

export const PopUpRedAlertPhoneNumber = styled(PopUpRedAlertText)`
  min-width: 200px;
  text-align: center;

  img {
    margin-right: 10px;
  }
`;

export const PopUpRedAlertInfoRow = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  border-radius: 4px;
  background: ${({ theme }) => theme.palette.error.main};

  box-shadow: 0px 4px 50px 0px ${({ theme }) => theme.palette.grey[500]};
`;

export const PopUpRedAlertAcceptButton = styled(Button)`
  margin-left: 20px;
  margin-right: 8px;
`;

export const PopUpRedAlertTimePassed = styled(PopUpRedAlertText)`
  min-width: 85px;
  text-align: right;
  color: ${({ theme }) => theme.palette.common.white};
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 24px */
  letter-spacing: 0.15px;
`;
